<template>
  <div class="activity-redirect">
    <van-loading size="24px" vertical color="#333">加载中...</van-loading>
  </div>
</template>

<script>
import { getSignStoreActivityDetailByCode } from '@/api/signstore'
import { Toast } from 'vant'

// H5 端用户唯一标识在本地缓存的 key
const H5_UID_KEY = 'signstore_h5_uid'

// 简易 UUID 生成：32 位十六进制 + 前缀，已足够作为匿名用户标识
function createH5Uuid() {
  const hex = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
  return `h5-${hex}`
}

function getOrCreateH5Uid() {
  try {
    const stored = window.localStorage.getItem(H5_UID_KEY)
    if (stored) return stored
    const id = createH5Uuid()
    window.localStorage.setItem(H5_UID_KEY, id)
    return id
  } catch (e) {
    // 本地存储异常时，仍然返回一次性的 uuid，后端仍可识别一次会话
    return createH5Uuid()
  }
}

/**
 * 活动跳转页（与小程序 activityRedirect 逻辑一致）
 * 支持 activity_code 或 scene 参数，拉取活动详情后根据配置跳转到对应模板页
 * 同一配置：小程序用 miniProgramPath，H5 用映射后的 path
 * 这里同时为 H5 生成匿名用户ID（h5Uuid），后续打卡接口作为用户标识使用
 */
export default {
  name: 'ActivityRedirect',
  data() {
    return {
      activityCode: null
    }
  },
  mounted() {
    const query = this.$route.query
    let activityCode = query.activity_code || null
    if (!activityCode && query.scene) {
      activityCode = decodeURIComponent(query.scene)
    }
    if (activityCode) {
      this.activityCode = activityCode
      this.loadActivityDetail()
    } else {
      Toast('活动编码不存在')
      setTimeout(() => {
        this.$router.replace('/index')
      }, 1500)
    }
  },
  methods: {
    async loadActivityDetail() {
      try {
        const params = { activityCode: this.activityCode }
        const res = await getSignStoreActivityDetailByCode(params)
        if (!res || res.status !== 200) {
          throw new Error((res && res.msg) || '获取活动详情失败')
        }
        const activityData = res.data
        if (!activityData || !activityData.id) {
          throw new Error('活动数据不完整')
        }
        // 生成或读取 H5 用户唯一标识
        const h5Uid = getOrCreateH5Uid()
        // 小程序路径如 /pages/template/activity3，映射为 H5 路径 /template/activity3（同一配置双端）
        const miniPath = (activityData.miniProgramPath || '').trim()
        let h5Path = miniPath ? ('/' + miniPath.replace(/^\//, '')).replace(/^\/pages\//, '/') : '/template/activity3'
        if (!h5Path.startsWith('/')) h5Path = '/' + h5Path
        const redirectUrl =
          `${h5Path}?id=${activityData.id}` +
          `&activity_code=${encodeURIComponent(this.activityCode)}` +
          `&h5_uid=${encodeURIComponent(h5Uid)}`
        this.$router.replace(redirectUrl)
      } catch (error) {
        Toast(error.message || '加载活动失败')
        setTimeout(() => {
          this.$router.replace('/index')
        }, 2000)
      }
    }
  }
}
</script>

<style scoped lang="less">
.activity-redirect {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #f5f5f5;
}
</style>
